import { Button, Divider, Grid, SwipeableDrawer } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import React from "react";
import { StyledBadge, useDrawerStyles } from "./styles";

export interface DrawerProps {
    value: string;
    initRightValue: boolean;
    name: string;
    icon: unknown;
    content: unknown;
    title: string;
    notif?: boolean;
  }


  type Anchor = 'right';
export const Drawer = ({name, icon, value, content, initRightValue, title, notif}: DrawerProps) => {
    const [openDrawer, setOpenDrawer] = React.useState({right: initRightValue});
    const styles = useDrawerStyles();

    const toggleDrawer = (anchor: Anchor, open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
      ) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }
    
        setOpenDrawer({ ...openDrawer, [anchor]: open });
      };
    const displayDetails = (anchor: Anchor) => (

        <div
          role="presentation"
          className={styles.drawerStyle }
          onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className={styles.title}>
              <span>{title}</span>
            <span className={styles.icon} onClick={toggleDrawer(anchor, false)}>
                <CloseIcon className={styles.iconStyle}/>
            </span>
            </div>
            <Divider/>
         {content}
        </div>
      );
    return (
      <Grid className={styles.root}>
        {([value] as Anchor[]).map((anchor) => (
          <React.Fragment key={anchor}>
            {notif ? (
              <div className={styles.rootBadge} onClick={toggleDrawer(anchor, true)}>
                <StyledBadge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  variant="dot"
                >
                  {name} &nbsp; &nbsp; &nbsp;
                  {icon}
                </StyledBadge>
              </div>
            ) : (
              <div className={styles.buttonDrawer} onClick={toggleDrawer(anchor, true)}>
                {name} &nbsp; &nbsp; &nbsp;
                {icon}
              </div>
            )}
            <SwipeableDrawer
              className={styles.rootDrawer}
              anchor={anchor}
              open={openDrawer[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              {displayDetails(anchor)}
            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </Grid>
    );
}
